import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useReportsSummaries } from "./hook/reportsSummaries.hook";
import { ReportsSummariesView } from "./view/reportsSummaries.view";
export var ReportsSummaries = function () {
    var _a;
    var p = useReportsSummaries();
    return (_jsx(ReportsSummariesView, { loading: p.loading, toast: p.toast, setToast: p.setToast, columns: p.columns, rows: p.rows, reportName: p.reportName, onBack: p.onBack, onChangeFilter: p.onChangeFilters, onClearFilter: p.onClearFilter, onExportReport: p.onExportReport, htmlContent: (_a = p.htmlData) !== null && _a !== void 0 ? _a : "" }));
};
